import * as React from 'react';

export const NavigationContext = React.createContext({
	navStatus: {},
	navBarToggleClickHandler: () => { }
});

export const NavigationState = (props: any) => {
	const [navStatus, setnavStatus] = React.useState({
		navBarOpen: true
	});

	const navBarToggleClickHandler = () => {
		if (navStatus.navBarOpen) {
			setnavStatus({
				navBarOpen: false
			});
		} else {
			setnavStatus({
				navBarOpen: true
			});
		}
		// console.log('sideBar toggle: ', navStatus);
	};

	return (
		<NavigationContext.Provider
			value={{
				navStatus: navStatus.navBarOpen,
				navBarToggleClickHandler: navBarToggleClickHandler
			}}
		>
			{props.children}
		</NavigationContext.Provider>
	);
};

// export default NavigationState;
